import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { DioService } from './../../../shared/services/dio.service';
import { 
  GetUsersDioScheduledVisitsByActiveVoucherRequest, GetUsersDioScheduledVisitsByActiveVoucherResponse, 
  GetServedServicePointsByActiveVoucherResponse, GetServedServicePointsByActiveVoucherRequest,
  GetServedServicePointsForUnloadingResponse, GetServedServicePointsForUnloadingRequest, 
  GetServedServicePointsForUnloadingModel, PostServedServicePointRequest, PostServedServicePointResponse, 
  UnloadServicePointsRequest 
} from './../../../shared/models/dio.models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'service-point-manager.component.html',
  styleUrls: ['./service-point-manager.component.scss']
})
export class ServicePointManagerComponent implements OnInit {

  usersDioScheduledVisitsResponse: GetUsersDioScheduledVisitsByActiveVoucherResponse | null = null;
  visitedServicePointsResponse: GetServedServicePointsByActiveVoucherResponse | null = null;
  servedServicePointsForUnloadingResponse: GetServedServicePointsForUnloadingResponse | null = null;
  selectedUnloadingValues: GetServedServicePointsForUnloadingModel[] = [];
  unloadingButtonEnabled = true;
  messageBoxConfirmScheduleUsingVisible = false;
  pickedScheduleId: number | null = null;
  loading: boolean = true;
  private loadCounter: number = 0;
  confirmMessage: string = '';
  isMobile: boolean = false;
  errorPopupVisible = false;
  errorMessage: string = '';

  constructor(
    private dioService: DioService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.loadScheduledServicePoints();
    this.loadServedServicePoints();
    this.loadServedServicePointsForUnloading();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  private checkLoadingStatus() {
    this.loadCounter++;
    if (this.loadCounter === 3) {
      this.loading = false;
    }
  }

  loadScheduledServicePoints() {
    const request: GetUsersDioScheduledVisitsByActiveVoucherRequest = {};
    this.dioService.getUsersDioScheduledVisits(request).subscribe((response: GetUsersDioScheduledVisitsByActiveVoucherResponse) => {
      this.usersDioScheduledVisitsResponse = response;
      this.checkLoadingStatus();
    });
  }

  loadServedServicePoints() {
    const request: GetServedServicePointsByActiveVoucherRequest = {};
    this.dioService.getServedServicePoints(request).subscribe((response: GetServedServicePointsByActiveVoucherResponse) => {
      this.visitedServicePointsResponse = response;
      this.checkLoadingStatus();
    });
  }

  loadServedServicePointsForUnloading() {
    const request: GetServedServicePointsForUnloadingRequest = {};
    this.dioService.getServedServicePointsForUnloading(request).subscribe((response: GetServedServicePointsForUnloadingResponse) => {
      this.servedServicePointsForUnloadingResponse = response;
      this.selectedUnloadingValues = response.dioServedServicePointsForUnloading;
      this.checkLoadingStatus();
    });
  }

  startUnloading() {
    this.unloadingButtonEnabled = false;
    const request: UnloadServicePointsRequest = {
      servedServicePointIdList: this.selectedUnloadingValues.map(x => x.id ?? 0)
    };
    this.dioService.unloadServicePoints(request).subscribe(
      () => {
        this.loadServedServicePointsForUnloading();
        this.unloadingButtonEnabled = true;
      },
      (error) => {
        if (error.status === 400) {
          error.error.ValidationErrors.forEach((validationError: any) => {
            const invalidItem = this.selectedUnloadingValues.find(item => item.id === validationError.id);
          });
          this.translate.get('UnloadServicePointsError').subscribe((translatedMessage: string) => {
            this.errorMessage = translatedMessage;
            this.errorPopupVisible = true;
          });
        }
        this.unloadingButtonEnabled = true;
      }
    );
  }
  
  navigateToVoucher() {
    this.router.navigate(['/voucher']);
  }

  navigateToNewVisitServicePoint() {
    this.router.navigate(['/new-visit-service-point']);
  }

  openVisitedServicePoint(id: number) {
    this.router.navigate([`/visited-service-point/${id}`]);
  }

  createNewServedPointByScheduled(id: number) {
    this.pickedScheduleId = id;
    const selectedVisit = this.usersDioScheduledVisitsResponse?.dioScheduledVisitsList.find(x => x.id === id);
    if (selectedVisit) {
        this.translate.get('ScheduledDioConfirmMessage').subscribe((translatedMessage: string) => {
            this.confirmMessage = `${translatedMessage} "${selectedVisit.servicePointName}"?`;
            if (selectedVisit.visitComment) {
                this.confirmMessage += `\n${selectedVisit.visitComment}`;
            }
            this.messageBoxConfirmScheduleUsingVisible = true;
        });
    } else {
        console.error('Selected visit not found for id:', id);
    }
}

  confirmScheduleUsing() {
    this.messageBoxConfirmScheduleUsingVisible = false;
    const request: PostServedServicePointRequest = {
      dioScheduledVisitId: this.pickedScheduleId!
    };
    this.dioService.postServedServicePoint(request).subscribe(
      (response: PostServedServicePointResponse) => {
        if (response && response.id) {
          this.router.navigate([`/visited-service-point/${response.id}`]);
        } else {
          console.log('PostServedServicePoint request failed: No ID in response');
        }
      },
      (error) => {
        console.error('PostServedServicePoint request failed:', error);
      }
    );
}

  cancelScheduleUsing() {
    this.messageBoxConfirmScheduleUsingVisible = false;
    this.pickedScheduleId = null;
  }

  onSelectionChanged(event: any) {
    this.selectedUnloadingValues = event.selectedRowsData;
  }
  
}